export default {
  methods: {
    openSubscriptionModal(key) {
      this.$store.dispatch('setSubscriptionModalTextToUse', key)
      this.$refs.subscriptionmodal.open()
    },
    async updateEvent(eventId, properties, data) {
      try {
        const update = await this.$axios({
          headers: { Authorization: this.$store.state.user.sessionInfo.token },
          data: {
            query: `
            mutation UpdateEvent($EventId: ID!, $UpdateEvent: UpdateEventInput!){
              UpdateEvent(eventId:$EventId, input:$UpdateEvent){
                id
              }
            }
            `,
            variables: {
              UpdateEvent: properties,
              EventId: eventId,
            },
          },
        })

        if (update.data.errors) {
          throw update.data.errors[0]
        }

        // Update the data object with the new properties if an updated is needed

        if (data) {
          Object.keys(properties).forEach((key) => {
            data[key] = properties[key]
          })
        }
        this.$store.dispatch('showMessage', {
          show: true,
          message: 'Updated',
          type: 'success',
        })

        return update.data.data.UpdateEvent
      } catch (err) {
        this.$store.dispatch('showMessage', {
          show: true,
          message: err.message || 'Error',
          type: 'error',
        })
      } finally {
        this.descriptionChanged = false
      }
    },
    async updateTour(tourId, properties, data) {
      try {
        const update = await this.$axios({
          headers: { Authorization: this.$store.state.user.sessionInfo.token },
          data: {
            query: `
            mutation UpdateTour($TourId: ID!, $UpdateTour: UpdateTourInput!){
              UpdateTour(tourId:$TourId, input:$UpdateTour){
                id
              }
            }
            `,
            variables: {
              UpdateTour: properties,
              TourId: tourId,
            },
          },
        })

        if (update.data.errors) {
          throw update.data.errors[0]
        }

        // Update the data object with the new properties if an updated is needed

        if (data) {
          Object.keys(properties).forEach((key) => {
            data[key] = properties[key]
          })
        } else {
          this.loadData(tourId)
        }

        this.$store.dispatch('showMessage', {
          show: true,
          message: 'Updated',
          type: 'success',
        })

        return update.data.data.UpdateTour
      } catch (err) {
        this.$store.dispatch('showMessage', {
          show: true,
          message: err.message || 'Error',
          type: 'error',
        })
      }
    },
    async togglePublishedStatus(tourId, status) {
      let tourQuery = `
        mutation {
          UnPublishTour(tourId:"${tourId}"){
            id
          }
        }
      `
      if (status === true) {
        tourQuery = `
        mutation {
          PublishTour(tourId:"${tourId}"){
            id
          }
        }
        `
      }

      try {
        const publish = await this.$axios({
          headers: { Authorization: this.$store.state.user.sessionInfo.token },
          data: {
            query: tourQuery,
          },
        })

        if (publish.data.errors) {
          throw publish.data.errors[0]
        }

        this.$store.dispatch('showMessage', {
          show: true,
          message: status
            ? 'Published successfully'
            : 'Unpublished successfully',
          type: 'success',
        })
        this.$store.dispatch('loadManagerMenuData', this.$route.params.eventId)
      } catch (err) {
        this.$store.dispatch('showMessage', {
          show: true,
          message: err.message || 'Error',
          type: 'error',
        })
      }
    },
  },
}
